(function() {
    // 1. İsimleri Kusursuzlaştır: (Örn: "Dark Brown" -> "darkbrown", "color: dark-brown" -> "darkbrown")
    // Bu sayede büyük/küçük harf, boşluk veya tire hataları %100 önlenir.
    function normalize(str) {
        return (str || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    // 2. Görselden Rengi Oku (Alt Text)
    function getAltColor(altText) {
        let alt = (altText || '').toLowerCase().replace(/\s+/g, '');
        if (alt.includes('color:')) return normalize(alt.split('color:')[1]);
        if (alt.includes('renk:')) return normalize(alt.split('renk:')[1]);
        return null; // Renk etiketi yoksa null döner
    }

    // 3. Sayfa ilk açıldığında seçili olan rengi formdan bul
    function getInitialSelectedColor() {
        const fieldsets = document.querySelectorAll('fieldset, .product-form__input, .variant-picker__option');
        for (let fieldset of fieldsets) {
            const legend = fieldset.querySelector('legend, .form__label, .product-form__label, .variant-picker__option-name');
            const titleText = legend ? legend.textContent.toLowerCase() : '';
            
            // Sadece Color/Renk başlıklarına odaklan
            if (titleText.includes('color') || titleText.includes('renk') || titleText.includes('colour')) {
                const radios = fieldset.querySelectorAll('input[type="radio"]');
                for (let radio of radios) {
                    if (radio.checked) return normalize(radio.value); 
                }
            }
        }
        return null;
    }

    // 4. ANA FİLTRE MOTORU (Seçili renge göre ayrım yapar ve gizler)
    function filterGallery(targetColor) {
        if (!targetColor) return;

        const images = document.querySelectorAll('img[alt], picture img[alt], media-image img[alt]');
        let hasMatch = false;

        images.forEach(img => {
            const altColor = getAltColor(img.getAttribute('alt'));
            
            // Sadece Alt metninde renk etiketi olan görsellerle işlem yap (Genel fotoğrafları elleme)
            if (altColor) {
                // Görselin en dıştaki Prestige kapsayıcılarını bul
                const wrappers = [
                    img.closest('.product-gallery__item'),
                    img.closest('.product-gallery__media'),
                    img.closest('.carousel__cell'),
                    img.closest('.carousel__slide'),
                    img.closest('.product__media-item'),
                    img.closest('.product-gallery__thumbnail'),
                    img.closest('.thumbnail'),
                    img.closest('.product__thumbnail')
                ];

                wrappers.forEach(w => {
                    if (w) {
                        if (altColor === targetColor) {
                            // SEÇİLİ RENKLE EŞLEŞİYORSA GÖSTER
                            w.style.setProperty('display', '', 'important'); 
                            hasMatch = true;
                        } else {
                            // EŞLEŞMİYORSA ZORLA (IMPORTANT) GİZLE! Temanın kaydırmasını iptal eder.
                            w.style.setProperty('display', 'none', 'important'); 
                        }
                    }
                });
            }
        });

        // Temanın kaydırıcısını (slider) kalan fotoğraflara göre uyarla
        if (hasMatch) {
            setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
            setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
            
            // Kaymayı engellemek için kalan ilk görsele otomatik odaklan
            const firstVisibleThumb = document.querySelector('.product-gallery__thumbnail:not([style*="none"]) button, .thumbnail:not([style*="none"]) button');
            if (firstVisibleThumb) firstVisibleThumb.click();
        }
    }

    // 5. SİSTEMİ TETİKLEYİCİLER
    function init() {
        // A) Sayfa ilk açıldığında çalıştır
        setTimeout(() => {
            const initialColor = getInitialSelectedColor();
            if (initialColor) filterGallery(initialColor);
        }, 300);

        // B) KESİN ÇÖZÜM: Kullanıcı bir yuvarlağa TIKLADIĞI AN rengi havada yakala
        document.addEventListener('click', function(e) {
            const label = e.target.closest('label'); // Tıklanan label'ı bul
            if (!label) return;

            const inputId = label.getAttribute('for');
            if (!inputId) return;

            const input = document.getElementById(inputId);
            if (!input || input.type !== 'radio') return;

            // Bu tıkladığı radio buton "Renk" grubuna mı ait?
            const fieldset = input.closest('fieldset, .product-form__input, .variant-picker__option');
            if (!fieldset) return;

            const legend = fieldset.querySelector('legend, .form__label, .variant-picker__option-name');
            const titleText = legend ? legend.textContent.toLowerCase() : '';

            // Evet, kullanıcı "Renge" tıkladı! 
            if (titleText.includes('color') || titleText.includes('renk') || titleText.includes('colour')) {
                // Tıkladığı rengin adını al ve hemen filtreyi çalıştır!
                const clickedColor = normalize(input.value);
                
                // Tema fotoğrafları kaydırmadan biz saniyesinde gizliyoruz
                setTimeout(() => filterGallery(clickedColor), 10);
                setTimeout(() => filterGallery(clickedColor), 150); // Tema DOM'u değiştirirse diye yedek koruma
            }
        });
    }

    // Tarayıcı hazır olunca çalıştır
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();